import styled from 'styled-components'

import { _XS_Normal, Button, mainColors } from '@avantstay/backoffice-core'

export const Root = styled.div<{ $isHidden: boolean }>`
  display: ${({ $isHidden }) => ($isHidden ? 'none' : 'block')};
  flex: none;
  border-top: 1px solid ${mainColors.neutralMedium};
  background: ${mainColors.neutralExtraLight};
  padding: 12px 16px;

  & textarea {
    background-color: ${mainColors.white};
  }
`

export const ModeSwitch = styled.div`
  display: inline-flex;
  margin-bottom: 8px;
`

export const Variants = styled.div`
  display: grid;
`

export const Variant = styled.div<{ $isActive: boolean }>`
  grid-area: 1 / 1;
  min-width: 0;
  visibility: ${({ $isActive }) => ($isActive ? 'visible' : 'hidden')};
`

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
`

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const Hint = styled.p`
  ${_XS_Normal};

  color: ${mainColors.neutralExtremelyDark};
  overflow-wrap: anywhere;
`

export const SubmitButton = styled(Button.Primary)`
  width: auto;
  flex: none;
  margin-left: auto;
`
